import React, { useEffect, useRef, useState } from "react"

import styles from "../styles/about.module.css"
import rewards from "../assets/images/gift.svg"
import todos from "../assets/images/todo.svg"
import habits from "../assets/images/habit.svg"
import graph from "../assets/images/graph.svg"

const data = [
  {
    key: 0,
    icon: rewards,
    title: "Rewards",
    points: [
      {
        key: 0,
        text:
          "Set rewards and work towards unlocking them by earning enough xp",
      },
      {
        key: 1,
        text:
          "Decide on the duration and recurrence of the reward (daily, weekly, monthly, custom or ongoing).",
      },
      {
        key: 2,
        text:
          "Challenge yourself by setting the amount of xp required to unlock it",
      },
    ],
  },
  
  {
    key: 1,
    icon: todos,
    title: "To dos",
    points: [
      {
        key: 0,
        text:
          "Award yourself more xp for completing the items you're least looking forward to",
      },
      {
        key: 1,
        text: "Set what date this item needs to be completed by or on",
      },
      {
        key: 2,
        text:
          "Earn bonus xp for completing it quickly or on the day you committed to",
      },
    ],
  },{
    key: 2,
    icon: habits,
    title: "Habits",
    points: [
      {
        key: 0,
        text:
          "Create a list of habits you're trying to adopt as well as those you're trying to kick",
      },
      {
        key: 1,
        text:
          "Set how regularly you'll complete the habit and how much xp you should earn for on each iteration of the habit",
      },
      {
        key: 2,
        text:
          "Earn bonus xp for hitting your target and build up a streak",
      },
    ],
  },
  {
    key: 3,
    icon: graph,
    title: "Extras",
    points: [
      {
        key: 0,
        text:
          "Analyse your progress overall and for individual habits",
      },
      {
        key: 1,
        text:
          "Set reminders for your to dos",
      },
      {
        key: 2,
        text:
        "Share and compare your progress with friends",
      },
    ],
  },
]

export default function About() {
  const [inView, setInView] = useState(false)
  const [inView2, setInView2] = useState(false)
  const ref = useRef()
  const ref2 = useRef()
  useEffect(() => {
    var rect =
      ref?.current?.getBoundingClientRect().top - window.innerHeight + 100
    var rect2 =
      ref2?.current?.getBoundingClientRect().top - window.innerHeight + 100
    window.addEventListener("scroll", () => {
      setInView(window.scrollY > rect)
      setInView2(window.scrollY > rect2)
    })
  }, [])

  const bgClassName = inView ? styles.inView : styles.outView
  const bgClassName2 = inView2 ? styles.inView : styles.outView

  return (
    <section className={styles.container}>
      <h1 className={styles.title}>How it works</h1>
      <h4 className={styles.text}>
        The goal is to use the same techniques that games use to keep
        us hooked and direct them at productivity.. Earn experience points (xp) for completing tasks, build up streaks, unlock rewards and more! {" "}
      </h4>
      <div className={[styles.row, bgClassName].join(" ")} ref={ref}>
        <div className={styles.content}>
          <div className={styles.card}>
            <div className={styles.header}>
              <img alt={data[0].title} src={data[0].icon} className={styles.icon} />
              <h2>{data[0].title}</h2>
            </div>
            {data[0].points.map((item, i) => (
              <p key={item.key}> + {item.text}</p>
            ))}
          </div>
        </div>
        <div className={[styles.content, styles.right].join(" ")}>
          <div className={styles.card}>
            <div className={styles.header}>
              <img alt={data[1].title} src={data[1].icon} className={styles.icon} />
              <h2>{data[1].title}</h2>
            </div>
            {data[1].points.map((item, i) => (
              <p key={item.key}> + {item.text}</p>
            ))}
          </div>
        </div>
      </div>
      <div className={[styles.row, bgClassName2].join(" ")} ref={ref2}>
        <div className={[styles.content].join(" ")}>
          <div className={styles.card}>
            <div className={styles.header}>
              <img alt={data[2].title} src={data[2].icon} className={styles.icon} />
              <h2>{data[2].title}</h2>
            </div>
            {data[2].points.map((item, i) => (
              <p key={item.key}> + {item.text}</p>
            ))}
          </div>
        </div>
        <div className={[styles.content].join(" ")}>
          <div className={styles.card}>
            <div className={styles.header}>
              <img alt={data[3].title} src={data[3].icon} className={styles.icon} />
              <h2>{data[3].title}</h2>
            </div>
            {data[3].points.map((item, i) => (
              <p key={item.key}> + {item.text}</p>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}
